export default {
      id: "ar_location-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ar_location-usage",
      toString: function () {
        return this.url;
      }
    }